<template>
  <v-row>
    <v-col>
    <mandate-data-ntpi v-if="formData.mandate_kind == MandateKind.NTPI" :mandateData="formData" :inJournalType="inJournalType" :inJournalStatus="inJournalStatus" :isSubmandate="isSubmandate"/>
    <mandate-data-itpsi v-if="formData.mandate_kind == MandateKind.ITPSI" :mandateData="formData"/>
    <mandate-data-pp v-if="formData.mandate_kind == MandateKind.PP" :mandateData="formData"/>
    <mandate-data-itpsp v-if="formData.mandate_kind == MandateKind.ITPSP" :mandateData="formData"/>
    </v-col>
  </v-row>
</template>

<script>
import Enums from '@/enums'
import MandateKind from '@/components/constants/mandateKind'
import MandateDataNtpi from './MandateDataNTPI.vue'
import MandateDataItpsi from './MandateDataITPSI.vue'
import MandateDataPp from './MandateDataPP.vue'
import MandateDataItpsp from './MandateDataITPSP.vue'

export default {
  name: 'MandateData',
  components: {MandateDataNtpi, MandateDataItpsi, MandateDataPp, MandateDataItpsp},
  props: {
    formData: [Array, Object],
    inJournalType: [Number, String],
    inJournalStatus: [Number, String],
    isSubmandate: [Boolean]
  },
  data() {
    return {
      MandateKind: MandateKind
    }
  },
  computed: {
    formatedTerms() {
      return Enums.terms
    },
    formatedLogicSelect() {
      return Enums.logicSelect
    },
    showTermEvent() {
      return this.formData.term === '1103'
    },
    showTermDate() {
      return this.formData.term === '1101'
    },
    showDataAlloewdFields() {
      return this.formData.data_allowed
    },
    personsApproved() {
      return [
        {
          label: 'TEST',
          value: '1',
        },
        {
          label: 'TEST',
          value: '2',
        },
      ]
    },
  },
  methods: {
    newPersonApproved() {
      // save and push classifierAuthorizingPersons
    },
  },
}
</script>

<style>
</style>